/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const Jijia = {
  path: '/jijia',
  name: 'jijia',
  redirect: { name: 'jijia-device' },
  component: () => import('@/views/jijia/index.vue'),
  children: [
    {
      path: 'device',
      name: 'jijia-device',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/device.vue'),
    },
    {
      path: 'device-verify',
      name: 'jijia-device-verify1',
      redirect: { name: 'jijia-device-verify-order' },
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/empty.vue'),
    },

    {
      path: 'order',
      name: 'jijia-order-list',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/order-list.vue'),
    },
    {
      path: 'apply-invoice',
      name: 'jijia-apply-invoice',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/apply-invoice.vue'),
    },
    {
      path: 'introduce',
      name: 'jijia-introduce',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/introduce.vue'),
    },
    {
      path: 'contract',
      name: 'jijia-contract',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/contract.vue'),
    },
    {
      path: 'policy',
      name: 'jijia-policy',
      component: () => import(/* webpackChunkName: "jijia" */ '@/views/jijia/policy.vue'),
    },
  ],
}
export default Jijia
